import { render, staticRenderFns } from "./advice.vue?vue&type=template&id=d2565428"
import script from "./advice.js?vue&type=script&lang=js&external"
export * from "./advice.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports